// The landscape iPad in the home page's hero (TOM-980): the Neomaris app showing
// Gallivant RP at anchor, with her chart, readings and Neo's panel. The device
// is one picture to assistive technology (role="img" with IPAD_LABEL). The dated
// caption and the chart's data credit sit under it, outside the picture, so the
// credit's link stays usable.
import type { RefObject } from 'react';

import { ANCHORAGE_LAND_ATTRIBUTION, ANCHORAGE_LAND_ATTRIBUTION_URL } from './anchorageLand';
import { HomeChart } from './HomeChart';
import { HomeChat } from './HomeChat';
import { ChartReadouts, IpadCards } from './HomeReadouts';
import {
  IPAD_LABEL,
  SCENE_ANCHORAGE,
  SCENE_BOAT,
  SCENE_CAPTION,
  SCENE_HEADLINE,
} from './homeScene';

export function HomeIpad({ heroRef }: { heroRef: RefObject<HTMLElement | null> }) {
  return (
    <figure className="home-ipad-figure">
      <div className="home-ipad" role="img" aria-label={IPAD_LABEL}>
        <span className="home-ipad__camera" />
        <div className="home-ipad__screen">
          <div className="home-ipad__top">
            <div className="home-ipad__title">
              <span className="home-ipad__label home-ipad__label--place">
                AT ANCHOR · {SCENE_ANCHORAGE.toUpperCase()}
              </span>
              <span className="home-ipad__boat">{SCENE_BOAT}</span>
            </div>
            <div className="home-ipad__status">
              <span className={`home-ipad__pill home-tone--${SCENE_HEADLINE.tone}`}>
                <span className="home-dot" />
                <span className="home-ipad__pill-text">
                  <span className="home-ipad__who">Neo · </span>
                  {SCENE_HEADLINE.text}
                </span>
              </span>
              <span className="home-avatar">N</span>
            </div>
          </div>
          <div className="home-ipad__board">
            <div className="home-ipad__chart">
              <HomeChart />
              <ChartReadouts />
            </div>
            <IpadCards />
          </div>
          <HomeChat heroRef={heroRef} />
        </div>
      </div>
      <figcaption className="home-ipad-figure__caption">
        {SCENE_CAPTION}{' '}
        <span className="home-ipad-figure__credit">
          Map data{' '}
          <a href={ANCHORAGE_LAND_ATTRIBUTION_URL} target="_blank" rel="noopener noreferrer">
            {ANCHORAGE_LAND_ATTRIBUTION}
          </a>
          .
        </span>
      </figcaption>
    </figure>
  );
}
